import LocalStorageService from '../services/LocalStorageService';
import api from './APIService';

class AuthService {
	getUserCurrent() {
		return api.fetch({ method: 'get', path: '/users/current' });
	}
	registrationParticipant($data,$type) {
		if($type=="Spectator")
			return api.fetch({ method: 'post', path: '/participant/registration/spectator', data: $data });		
		
		return api.fetch({ method: 'post', path: '/participant/registration', data: $data });
	}
	getAuthParticipants(userId) {
		const localParticipants = LocalStorageService.getItem("select_parts_users") || [];
        const userListPart = localParticipants.find((el) => {
            return el.userId == userId;
        });
        if(userListPart) {
            return userListPart.participants;
        }
		return false;
	}
	setAuthParticipants(userId, participants) {
		const localParticipants = LocalStorageService.getItem("select_parts_users") || [];
        let band = false;
        localParticipants.forEach((el) => {
            if(el.userId == userId) {
                el.participants = participants;
                band = true;
            }
        });
        if(!band) {
            localParticipants.push({ userId: userId, participants });
        }
        LocalStorageService.setItem("select_parts_users", localParticipants);  
	}
	preventDuplicateEmail(email) {
		return api.fetch({ method: 'get', path: `/livelaps/user/preventDuplicateEmail/${email}` });
		
	}
	setCurrentKeepAlive() {
		return api.fetch({ method: 'get', path: '/users/current/keep-alive' });
	}	
}

export default new AuthService();
